import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import type { DetailRow, FunctionComponent } from './types';

import styles from './styles.module.scss';

type DetailsSectionProps = {
    rows: DetailRow[];
};

const DetailsSection: FunctionComponent<DetailsSectionProps> = ({ rows }) => {
    if (rows.length === 0) {
        return null;
    }

    return (
        <VerticalContainer className={styles.details}>
            {rows.map(row => (
                <HorizontalContainer className={styles.detailRow} key={row.label}>
                    <Wrapper className={styles.detailLabel}>{row.label}</Wrapper>

                    <Wrapper className={styles.detailValue}>{row.value}</Wrapper>
                </HorizontalContainer>
            ))}
        </VerticalContainer>
    );
};

export default DetailsSection;
